import { SelectionMenuViewMode } from '@components/ButtonBaseWithSelectionMenu/types/buttonBaseWithSelectionMenu.types';
import { ButtonStatusVariant } from '../../../components/ButtonWithFeddback';
import LangEnum from '../../../lang/LangEnum';
import { AllowChangeGrid } from '../../../services/modules/product-colors-packs/product-colors-packs.types';
import { Classification } from '../../classifications/classification.types';
import { Collection } from '../../collections/collections.types';
import { OfflineStatus } from '../../offline/domain/offlineOrder/offlineOrder.types';
import { UsedInOfflineMode } from '../../offline/types/UsedInOfflineMode';
import {
  AvailabilityEnum,
  DeliveryWindow,
  ESProductColor,
  ESProductMedia,
  ProductPageDTO,
} from '../../products/ProductTypes';
import { OrderProductSelectedPack } from '../../products/details/productDetails.types';
import { ColorClassification } from '../../products/product.types.v2';
import { OrderStatus } from '../interfaces/order-status.interface';
import { OrderItemPriceComposition } from '../order.types';
import { DeliveryWindowAvailability } from './add-product/deliveryWindowSelect.types';
import { SuggestedGridItem } from './product/suggestedGrid/suggested-grid.interface';

export enum AddOrderProductMode {
  PRODUCT = 'product',
  COLOR = 'color',
  SKU = 'sku',
}

interface MinimumAddOrderProductColorState {
  createOrderItems: UpdateItemFormat[];
}

export type MinimumAddOrderProductState = {
  deliveryWindow?: DeliveryWindow;
  availability: AvailabilityEnum;
  totals: Totals;
};

interface BaseAddOrderItemFormState extends MinimumAddOrderProductColorState {
  hash?: number;
  product: Pick<ProductPageDTO, 'id' | 'code' | 'name'> | null;
  loading: boolean;
  inputProductValue: string;
  hasError: boolean;
  errorMessage?: string;
}

export interface AddOrderProductKit {
  id: string;
  code: string;
  name: string;
}

export type AddOrderProductFormState = BaseAddOrderItemFormState &
  MinimumAddOrderProductState & {
    kit: AddOrderProductKit | null;
    color: ESProductColor | null;
    colors: ESProductColor[];
    grid: OrderProductGridItem[];
    suggestedGrid?: SuggestedGridItem[];
    suggestedPacks?: OrderProductSelectedPack[];
    hasValidPacks: boolean;
    selectedPacks: OrderProductSelectedPack[];
    submitButton: {
      isSubmitting: boolean;
      status: ButtonStatusVariant;
    };
    loadingColors: boolean;
  };

export type AddOrderProductColorsFormState = BaseAddOrderItemFormState & {
  deliveryWindow?: DeliveryWindow;
  color: ESProductColor | null;
  colors: ESProductColor[];
  grid: OrderProductGridItem[];
  loadingColors: boolean;
  availability: AvailabilityEnum;
  totals: Totals;
  submitButton: {
    isSubmitting: boolean;
    status: ButtonStatusVariant;
  };
};

export enum ModalLayoutEnum {
  LIST_WITH_PICTURES = 'LIST_WITH_PICTURES',
  LIST_NO_PICTURES = 'LIST_NO_PICTURES',
}

export enum OrderHeadersGroupByEnum {
  DEFAULT = 'NONE',
  DELIVERY_WINDOW = 'DELIVERY_WINDOW',
  COLLECTION = 'COLLECTION',
  CATEGORY = 'CATEGORY',
  SUB_CATEGORY = 'SUB_CATEGORY',
  COLOR_CLASSIFICATION_TYPE = 'COLOR_CLASSIFICATION_TYPE',
  PENDENCY = 'PENDENCY',
  PRODUCT = 'PRODUCT',
}

export type OrderHeadersGroupBy =
  | OrderHeadersGroupByEnum.DEFAULT
  | OrderHeadersGroupByEnum.DELIVERY_WINDOW
  | OrderHeadersGroupByEnum.COLLECTION
  | OrderHeadersGroupByEnum.CATEGORY
  | OrderHeadersGroupByEnum.SUB_CATEGORY
  | OrderHeadersGroupByEnum.COLOR_CLASSIFICATION_TYPE
  | OrderHeadersGroupByEnum.PENDENCY
  | OrderHeadersGroupByEnum.PRODUCT;

export type GroupByColorClassificationTypeInfo = {
  // TODO: ESSA TIPAGEM TA MEIO ERRADA, HORA CONSIDERAMOS QUE SERÁ STRING E OUTRA STRING[], ESTAVA INICIALMENTE COMO STRING, ALTEREI PARA STRING[] POIS NO OrderProductsGroupByMultiple TRATAMOS COMO ARRAY E DPS PERCEBI QUE HAVIA LOCAIS QUE OLHAVAM COMO STRING DE FATO, PRECISAMOS REFATORAR NÃO SÓ AQUI, MAS A LÓGICA DE AGRUPAMENTO TAMBÉM ESTA BEM COMPLEXO
  classificationTypeId: string[] | string;
};

export type OrderHeadersGroupByInfo = GroupByColorClassificationTypeInfo;

export enum ListSortViewEnum {
  LAST_ADDED = 'LAST_ADDED',
  PRODUCT_NAME_A_Z = 'PRODUCT_NAME_A_Z',
  CODE = 'CODE',
  REFERENCE_CODE = 'REFERENCE_CODE',
}

export type SortView =
  | ListSortViewEnum.CODE
  | ListSortViewEnum.LAST_ADDED
  | ListSortViewEnum.PRODUCT_NAME_A_Z
  | ListSortViewEnum.REFERENCE_CODE;

export enum OrderProductsViewActionsEnum {
  EXPAND_ALL = 'EXPAND_ALL',
  HIDE_ALL = 'HIDE_ALL',
  NONE = 'NONE',
}

export type OrderProductListViewType = SelectionMenuViewMode;

export interface ListCategoryDTO {
  id: string | null;
  parent?: ListCategoryDTO;
  parentId?: string;
  name: string;
  imageUrl: string;
  children: ListCategoryDTO[];
  uniqueSequential: number;
  classification: string;
}

export interface GetOrderItemsStatus {
  pendingQuantity: number;
  settledQuantity: number;
  canceledQuantity: number;
  reservedQuantity: number;
  pendingValue: number;
  settledValue: number;
  canceledValue: number;
  reservedValue: number;
}

export interface OrderItemListGridItemDTO {
  skuId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string;
  color: { id: string };
  orderItemId?: string;
  orderConditionId?: string;
  orderItemQuantity?: number;
  orderWholeSalePrice: number;
  orderPromotionalPrice?: number;
  priceComposition?: OrderItemPriceComposition;
}

export interface OrderProductGridItem {
  orderConditionId?: string;
  orderItemId?: string;
  orderItemQuantity?: number;
  orderItemKitId?: string;
  canceledQuantity: number;
  settledQuantity: number;
  pendingQuantity: number;
  reservedQuantity: number;
  orderWholeSalePrice: number;
  orderPromotionalPrice?: number;
  stock?: {
    availableAmount?: number | null;
    availableForSale: boolean;
  };
  available: boolean;
  deliveryWindowAvailable: boolean;
  availableForReadyForDeliveryWithoutStock: boolean;
  skuId: string;
  productSizeId: string;
  productSizeName: string;
  productSizeUnique: boolean;
  productSizeActive: boolean;
  productSizePosition: number;
  priceComposition?: OrderItemPriceComposition;
  skuKits: SkuKitProductGridDTO[];
}

export interface SkuKitProductGridDTO {
  kitId: string;
  kitName: string;
  id: string;
  quantity: number;
}

export interface OrderProduct {
  availability: AvailabilityEnum;
  code: string;
  orderConditionId?: string;
  color: ESProductColor;
  name: string;
  productColorId: string;
  productId: string;
  media: ESProductMedia;
  updatingAvailability: boolean;
  allowChangePreOrderGrid: AllowChangeGrid;
  allowChangeImmediateGrid: AllowChangeGrid;
  category?: ListCategoryDTO;
  collection?: Collection;
  deliveryWindow?: DeliveryWindow;
  colorClassifications?: ColorClassification[];
  referenceCode?: string;
  kit?: OrderProductKit;
}

export interface OrderProductKit {
  id: string;
  name: string;
  code: string;
  imageUrl?: string;
}

export interface Summary {
  deliveries: number;
  discount: number;
  pieces: number;
  quantity: number;
  subtotal: number;
  total: number;
  totalRetail?: number;
  grossValue?: number;
  priceComposition?: OrderItemPriceComposition;
  totalShippingCostValue?: number;
  totalChargesValue?: number;
}

export type ConditionSummary = Summary & { id: string };

export interface PriceCompositionTotals {
  id: string;
  label: string;
  totalValue: number;
}

export interface HeaderSection {
  availability?: AvailabilityEnum;
  deliveryWindowId?: string;
  subCategoryId?: string | null;
  multipleIdentifier?: string;
  categoryId?: string | null;
  classificationId?: string | null;
  collectionId?: string | null;
  withPendencies?: boolean;
  total: number;
  quantity: number;
  pieces: number;
  incomeStatus: GetOrderItemsStatus;
  productCode?: string;
  priceCompositionTotals: PriceCompositionTotals[];
}

export interface OrderCalculationHeaders {
  type: OrderHeadersGroupBy;
  sections: HeaderSection[];
}

export interface ClassificationToSection extends Omit<Classification, 'id'> {
  id: string | null;
}

export enum SectionPendencyEnum {
  WITH_PENDENCIES = 'WITH_PENDENCIES',
  WITHOUT_PENDENCIES = 'WITHOUT_PENDENCIES',
}

export interface Section {
  isExpanded: boolean;
  productsCount: number;
  availability?: AvailabilityEnum;
  deliveryWindow?: DeliveryWindow;
  collection?: Collection;
  category?: ListCategoryDTO;
  subCategory?: ListCategoryDTO;
  colorClassification?: ClassificationToSection;
  pendency?: SectionPendencyEnum;
  addProducts?: AddOrderProductFormState[];
  products: OrderProduct[];
  productTitle?: string;
  groupTitle?: string;
  parentGroupKey?: string;
  parentGroupTitle?: string;
  parentGroupTitleFallbackEntity?: LangEnum;
  groupTitleFallbackEntity?: LangEnum;
  lastRemovedProductIndex?: number | null;
  identifier?: string;
}

export type Totals = {
  itemsQuantity?: number;
  partsQuantity: number;
  total: number;
};

// Estado que gerencia a tela
export interface OrderProductsStateProps {
  isLoading: boolean;
  hasFetchedProducts: boolean;
  error?: string;
  sections: Array<Section>;
  collapsedParentGroupKeys: string[];
  products: Array<OrderProduct>;
  openBarcodeDialog: boolean;
  activeBarcodeDialog: boolean;
  orderItemsStatus?: GetOrderItemsStatus;
}

export interface UpdateItemFormat {
  id?: string;
  deliveryWindowId?: string | null;
  skuId?: string;
  quantity?: number;
  availability: AvailabilityEnum;
  productColorId?: string;
  orderConditionId?: string;
}

export interface UpdateItemFormatWithSize extends UpdateItemFormat {
  productSizeId: string;
}

export interface CreateOrUpdateOrderListWithKitParams {
  kitId: string;
  quantity: number;
  orderId: string;
}
export type GetProductSectionIndex = {
  productIndex: number;
  sectionIndex: number;
  sections: Section[];
};

export type CalculateProductSectionIndex = {
  productIndex: number;
  sectionIndex: number;
  sectionLengths: number[];
};

export type DeleteOrderProduct = {
  productId: string;
  productColorId?: string;
  availabilities?: AvailabilityEnum[];
  deliveryWindowId?: string;
};

export type OrderProductSelectionEdge = 'none' | 'single' | 'start' | 'middle' | 'end';

export type GetOrderProductSelectionEdge = {
  productIndex: number;
  orderProducts: OrderProduct[];
  selectedItems: Set<string>;
  groupStartIndexes: Set<number>;
};

export type OrderProductKeyIds = {
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string;
};

type OnSelectNewColorParams = {
  grid: OrderProductGridItem[];
  productColor: ESProductColor;
  productIndex: number;
  sectionIndex: number;
};

export type OnSelectNewColor = (params: OnSelectNewColorParams) => Promise<void>;

interface OnSelectNewDeliveryWindowParams {
  productIndex: number;
  sectionIndex: number;
  grid: OrderProductGridItem[];
  newAvailability: AvailabilityEnum;
  lastAvailability: AvailabilityEnum;
  dwAvailability?: DeliveryWindowAvailability;
}

export type OnSelectNewDeliveryWindow = (params: OnSelectNewDeliveryWindowParams) => Promise<void>;

export type OnSuccessAddProductWithPacks = (
  availability: AvailabilityEnum,
  productColorId?: string,
) => Promise<void>;

export interface OrderProductsProps extends UsedInOfflineMode {
  canEditOrder?: boolean;
  orderBrandHasIntegrations: boolean;
  orderId: string;
  orderStatus: OrderStatus | OfflineStatus;
  viewMode: OrderProductListViewType;
  isAddProductOpen?: boolean;
  addProductMode?: AddOrderProductMode;
  onToggleAddProduct?: () => void;
}
